<template>
  <DialogTemplate style="--dialog-content-padding: 0">
    <div class="ma-12 f-column">
      <div class="d-flex f-center clr-grey w-100">
        <div class="uppercase text-medium clr-grey mr-auto">Generate custom reports</div>
      </div>

      <div class="f-column text-centers text-normal-large weight_400 ml-auto mt-4">
        Your account will be deducted 50 credits.
      </div>
      <div></div>

      <div class="d-flex ml-autos mt-4">
        <div class="f-column w-100">
          <div
            class="gw_btn w-100 weight_600 text-normal-large pa-5"
            :class="'gw_btn_primary'"
            @click="apply()"
          >
            <div>Confirm</div>
          </div>
        </div>
      </div>
    </div>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'

export default {
  name: 'GenerateCustomReportsDialog',
  components: {
    DialogTemplate,
  },
  props: {
    dialog: Object,
  },
  methods: {
    apply() {
      console.log('Dispatch generate reports')
      this.close()
    },
    close() {
      this.$store.dispatch('router_rm_dialog', 'generate-custom-reports-dialog')
    },
  },
}
</script>

<style lang="scss" scoped></style>
